import PropTypes from "prop-types"
import React from "react"
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api"

const defaultCenter = { lat: 33.5731, lng: -7.5898 }
const libraries = ["places"]

const LocationPickerMap = ({ latitude, longitude, onChange }) => {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ""
  const { isLoaded, loadError } = useJsApiLoader({
    id: "wevalo-partner-google-maps",
    googleMapsApiKey: apiKey,
    libraries,
    language: "fr",
  })
  const hasPosition =
    latitude !== "" &&
    longitude !== "" &&
    Number.isFinite(Number(latitude)) &&
    Number.isFinite(Number(longitude))
  const position = hasPosition
    ? { lat: Number(latitude), lng: Number(longitude) }
    : defaultCenter

  const updatePosition = latLng => {
    if (!latLng) return
    onChange({
      latitude: Number(latLng.lat().toFixed(7)),
      longitude: Number(latLng.lng().toFixed(7)),
    })
  }

  if (!apiKey) {
    return (
      <div className="partner-map-fallback">
        Ajoutez <code>REACT_APP_GOOGLE_MAPS_API_KEY</code> pour choisir la position sur la carte.
      </div>
    )
  }

  if (loadError) {
    return <div className="partner-map-fallback">La carte est momentanément indisponible. Vous pouvez saisir les coordonnées.</div>
  }

  if (!isLoaded) {
    return <div className="partner-map-fallback">Chargement de la carte...</div>
  }

  return (
    <div className="partner-location-map">
      <GoogleMap
        mapContainerClassName="partner-location-map-canvas"
        center={position}
        zoom={hasPosition ? 16 : 12}
        onClick={event => updatePosition(event.latLng)}
        options={{
          fullscreenControl: false,
          mapTypeControl: false,
          streetViewControl: false,
          clickableIcons: false,
        }}
      >
        <Marker position={position} draggable onDragEnd={event => updatePosition(event.latLng)} />
      </GoogleMap>
      <div className="partner-map-tip">
        <i className="bx bx-move" />
        Glissez le pin exactement sur l’entrée de votre commerce
      </div>
    </div>
  )
}

LocationPickerMap.propTypes = {
  latitude: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  longitude: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
}

export default LocationPickerMap
